import React from "react";

export const FavouriteIcon = () => {
  return (
    <>
      <svg
        width="17"
        height="22"
        viewBox="0 0 17 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.54623 17.4575L2.549 21.6442C2.31216 21.8426 2.03068 21.9633 1.736 21.9929C1.44133 22.0224 1.14514 21.9596 0.880577 21.8114C0.616011 21.6632 0.393511 21.4356 0.237983 21.154C0.082454 20.8723 4.09609e-05 20.5478 0 20.2167V3.5673C0 2.62129 0.335757 1.71401 0.933458 1.04501C1.53116 0.376018 2.34182 0.000119186 3.18717 0H13.8128C14.6581 0.000119186 15.4688 0.376018 16.0665 1.04501C16.6642 1.71401 17 2.62129 17 3.5673V20.2162C17 20.5473 16.9175 20.8719 16.762 21.1535C16.6065 21.4351 16.384 21.6628 16.1194 21.8109C15.8549 21.9592 15.5587 22.022 15.264 21.9924C14.9693 21.9629 14.6878 21.8421 14.451 21.6437L9.45664 17.4575C9.18093 17.2265 8.84583 17.1017 8.50143 17.1017C8.15703 17.1017 7.82189 17.2265 7.54623 17.4575Z"
          fill="#888888"
          style={{
            fill: "#888888",
            fill: "color(display-p3 0.5333 0.5333 0.5333)",
            fillOpacity: "1",
          }}
        />
      </svg>
    </>
  );
};
